const Badge = {
  baseStyle: {
    borderRadius: 'full',
    px: '2',
    py: '0.5',
  },
  variants: {
    primary: {
      color: 'white',
      bg: 'primary.500',
    },
    secondary: {
      color: 'primary.500',
      bg: 'primary.50',
    },
    error: {
      color: 'danger.main',
      bg: 'danger.light',
    },
    success: {
      color: 'success.main',
      bg: 'success.light',
    },
    gray: {
      color: 'gray.300',
      bg: 'gray.strokeAndBg',
    },
    inverted: {
      color: 'primary.500',
      bg: 'white',
      boxShadow: 'level1',
    },
  },
  defaultProps: {
    variant: 'primary',
  },
};

export default Badge;
